import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import animateScrollTo from 'animated-scroll-to';

import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const styles = theme => ({
  list: {
    borderTop: `1px solid ${theme.palette.primary.A100}`,
  },
  paper: {
    boxShadow: theme.shadows[2],
  },
  paperAnchorTop: {
    top: 64,
  },
  modalRoot: {
    zIndex: 1100,
  },
  listItemTextPrimary: {
    color: theme.palette.grey[700],
  },
});

const LandingHeaderMobileMenu = ({
  history,
  location,
  menuOpen,
  onMenuClose,
  classes,
}) => {
  const scrollOptions = {
    offset: -74,
  };

  return (
    <Drawer
      anchor="top"
      ModalProps={{
        classes: {
          root: classes.modalRoot,
        },
        BackdropProps: {
          invisible: true,
        },
      }}
      open={menuOpen}
      onClose={onMenuClose}
      classes={{
        paper: classes.paper,
        paperAnchorTop: classes.paperAnchorTop,
      }}
    >
      <List
        disablePadding
        className={classes.list}
      >
        <ListItem
          button
          onClick={() => {
            onMenuClose();
            window.open('tel:877-728-5848', '_self');
          }}
        >
          <ListItemText
            primary="877-728-5848"
            classes={{
              primary: classes.listItemTextPrimary,
            }}
          />
        </ListItem>
        <ListItem
          button
          onClick={() => {
            onMenuClose();
            history.push('/#features');
            if (location.pathname === '/') {
              animateScrollTo(document.querySelector('#features'), scrollOptions);
            }
          }}
        >
          <ListItemText
            primary="Features"
            classes={{
              primary: classes.listItemTextPrimary,
            }}
          />
        </ListItem>
        <ListItem
          button
          onClick={() => {
            onMenuClose();
            history.push('/#reviews');
            if (location.pathname === '/') {
              animateScrollTo(document.querySelector('#reviews'), scrollOptions);
            }
          }}
        >
          <ListItemText
            primary="Reviews"
            classes={{
              primary: classes.listItemTextPrimary,
            }}
          />
        </ListItem>
        <ListItem
          button
          onClick={() => {
            onMenuClose();
            history.push('/faq');
          }}
        >
          <ListItemText
            primary="FAQ"
            classes={{
              primary: classes.listItemTextPrimary,
            }}
          />
        </ListItem>
        <ListItem
          button
          onClick={() => {
            onMenuClose();
            history.push('/blog');
          }}
        >
          <ListItemText
            primary="Blog"
            classes={{
              primary: classes.listItemTextPrimary,
            }}
          />
        </ListItem>
        <ListItem
          button
          onClick={() => {
            onMenuClose();
            window.open('/account/login', '_blank');
          }}
        >
          <ListItemText
            primary="Sign In"
            classes={{
              primary: classes.listItemTextPrimary,
            }}
          />
        </ListItem>
      </List>
    </Drawer>
  );
};

LandingHeaderMobileMenu.propTypes = {
  menuOpen: PropTypes.bool,
  onMenuClose: PropTypes.func,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    list: PropTypes.string.isRequired,
  }).isRequired,
};

LandingHeaderMobileMenu.defaultProps = {
  menuOpen: false,
  className: '',
  onMenuClose: () => {},
};

export default withRouter(
  withStyles(styles)(LandingHeaderMobileMenu),
);



// WEBPACK FOOTER //
// ./src/components/common/Layout/LandingHeader/LandingHeaderMobileMenu.js